import React, { useMemo, useState } from 'react'
import {
  FullTitle,
  SectionalTitle,
  SpiderSearchResponse,
} from '../../api/Spider'
import '../kyc/SearchResultsTable.css'
import { EmptyMessage } from '../kyc/EmptyMessage'
// import { EmptyMessage } from '../EmptyMessage'

export interface TableDataSpiderTrustsProps {
  results?: SpiderSearchResponse | null
  title: string
  onFullTitleRowClick?: (row: FullTitle) => void
  onSectionalTitleRowClick?: (row: SectionalTitle) => void
}

export const TableDataSpiderTrusts: React.FC<TableDataSpiderTrustsProps> = ({
  results,
  title,
  onFullTitleRowClick,
  onSectionalTitleRowClick,
}) => {
  const handleFullTitleClick = (erf: FullTitle) => () => {
    if (onFullTitleRowClick) onFullTitleRowClick(erf)
  }
  const handleSectionalTitleClick = (erf: SectionalTitle) => () => {
    if (onSectionalTitleRowClick) onSectionalTitleRowClick(erf)
  }

  const [titleType, setTitleType] = useState<'FULL' | 'SECTIONAL'>('FULL')

  const showEmpty = useMemo(
    () =>
      !results ||
      (titleType === 'FULL' && results.fullTitleCount === 0) ||
      (titleType === 'SECTIONAL' && results.sectionalTitleCount === 0),
    [results],
  )

  if (results === undefined) return null

  return (
    <div className="kyc-results-table-container">
      <div className="buttons">
        <div
          className={`tab-button ${titleType === 'FULL' ? 'active' : ''}`}
          onClick={() => setTitleType('FULL')}
        >
          Full Title {`(${results?.fullTitleCount ?? 0})`}
        </div>
        <div
          className={`tab-button ${titleType === 'SECTIONAL' ? 'active' : ''}`}
          onClick={() => setTitleType('SECTIONAL')}
        >
          Sectional Title {`(${results?.sectionalTitleCount ?? 0})`}
        </div>
      </div>
      <table>
        {titleType === 'FULL' && (
          <thead>
            <tr style={{ height: '40px' }}>
              <th>Owner</th>
              <th style={{ width: '70px' }}>ERF #</th>
              <th style={{ width: '70px' }}>Street #</th>
              <th>Address</th>
              <th>Suburb</th>
              {/* <th>Allotment</th>
            <th>CMA ID</th> */}
            </tr>
          </thead>
        )}
        {titleType === 'SECTIONAL' && (
          <thead>
            <tr style={{ height: '40px' }}>
              <th>Owner</th>
              <th style={{ width: '70px' }}>Section #</th>
              <th style={{ width: '100px' }}>Scheme #</th>
              <th>Scheme Name</th>
              <th>Address</th>
              <th>Suburb</th>
              {/* <th>Municipality Name</th> */}
              {/* <th>Allotment</th>
            <th>CMA ID</th> */}
            </tr>
          </thead>
        )}
        <tbody>
          {showEmpty && <EmptyMessage />}
          {titleType === 'FULL' &&
            results?.fullTitle.map((entry, index) => (
              <tr
                key={index}
                onClick={handleFullTitleClick(entry)}
                style={{ height: '30px' }}
              >
                <td>{entry.owner}</td>
                <td style={{ width: '70px' }}>{entry.erfNo}</td>
                <td style={{ width: '70px' }}>{entry.streetNo}</td>
                <td>{entry.address}</td>
                <td>{entry.suburb}</td>
                {/* <td>{entry.municipalityName || '-'}</td> */}
                {/* <td>{entry.allotment}</td>
            <td>{entry.cmaid}</td> */}
              </tr>
            ))}
          {titleType === 'SECTIONAL' &&
            results?.sectionalTitle.map((entry, index) => (
              <tr
                key={index}
                onClick={handleSectionalTitleClick(entry)}
                style={{ height: '30px' }}
              >
                <td>{entry.owner}</td>
                <td style={{ width: '70px' }}>{entry.sectionNo}</td>
                <td style={{ width: '100px' }}>{entry.schemeNo}</td>
                <td>{entry.schemeName}</td>
                <td>{entry.address}</td>
                <td>{entry.suburb}</td>
                {/* <td>{entry.municipalityName || '-'}</td> */}
                {/* <td>{entry.allotment}</td>
            <td>{entry.cmaid}</td> */}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  )
}

export default TableDataSpiderTrusts
